const TIMEZONE = 'America/Phoenix';

export const formatDate = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { timeZone: TIMEZONE, ...options });
  } catch {
    return String(dateStr);
  }
};

export const formatDateTime = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleString('en-US', { timeZone: TIMEZONE, ...options });
  } catch {
    return String(dateStr);
  }
};

export const formatTime = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleTimeString('en-US', { timeZone: TIMEZONE, ...options });
  } catch {
    return String(dateStr);
  }
};

export const ARIZONA_TIMEZONE = TIMEZONE;
